<script lang="ts">
	import { PortableText } from '@portabletext/svelte';
	import { _ } from 'utils/i18/i18n';
	import SanityTable from 'components/SanityTable/SanityTable.svelte';
	import type { IExchangeData } from 'customTypes/exchange';
	import formatNumber from 'utils/formatNumber';
	import activeCurrency from 'stores/activeCurrency';

	export let data: IExchangeData;
	export let dark = false;
	export let btcPrice: number;
	export let copywrite;
	let isAllTextShown = false;
	let textRef: HTMLElement;

	$: volumeChange =
		(data?.volume_sparkline_btc_1d[0] /
			data?.volume_sparkline_btc_1d[data?.volume_sparkline_btc_1d?.length - 1] -
			1) *
		100;

	$: dayVolume = btcPrice
		? formatNumber(
				(data?.trade_volume_1d_btc / btcPrice) * $activeCurrency.price,
				$activeCurrency.currency,
				false,
		  )
		: 0;
</script>

<div class="wrapper" class:dark>
	<h2 class="section-title" bind:this={textRef}>{$_('exchange.about')} {data?.name}</h2>
	<div class={`coin-information ${isAllTextShown ? 'open' : 'closed'}`}>
		<p class="description">
			{`${data?.customName ?? data?.name} ${$_('exchange.description.dayVolume')} ${dayVolume}. ${$_(
				'exchange.description.volume',
			)} ${
				volumeChange > 0 ? $_('exchange.description.up') : $_('exchange.description.down')
			} ${volumeChange.toFixed(2)}% ${$_('exchange.description.pastHours')}`}
			<br />
			<br />
			{`${$_('exchange.description.currently')}, ${data?.customName ?? data?.name} ${$_('exchange.description.ranks')} ${
				data?.trust_score_rank
			} ${$_('exchange.description.accordingTo')}  `}
			<br />
			<br />
			{`${data?.customName ?? data?.name} ${$_('exchange.description.has')} ${data?.totalCoins} ${$_(
				'exchange.description.coins',
			)} ${data?.totalMarkets} ${$_('exchange.description.markets')}`}
			<br />
		</p>

		{#if copywrite?.body}
			<div class="copywrite">
				<PortableText
					value={copywrite.body}
					components={{
						types: {
							table: SanityTable,
						},
					}}
					context={{ dark }}
				/>
			</div>
		{/if}
	</div>

	<button
		class="btn"
		on:click={() => {
			if (isAllTextShown)
				textRef.scrollIntoView({
					behavior: 'smooth',
				});
			isAllTextShown = !isAllTextShown;
		}}>{isAllTextShown ? 'Hide' : 'Read more'}</button
	>
</div>

<style lang="scss">
	@import './exchangeDescription.scss';
</style>
